import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
// import PropTypes from 'prop-types';
import CalenderIco from '../../../assets/images/calender-ico.png';
import 'react-datepicker/dist/react-datepicker.css';

import './DateInput.scss';

interface CustomProps {
  default?: Date;
  placeholder?: string;
  onChange: (value: Date) => void;
  gap?: 'sm' | 'md' | 'lg';
  name?: string;
  label?: string;
  error?: string;
  minDate?: Date;
  maxDate?: Date;
  filterDate?: (date: Date) => boolean;
  disabled?: boolean;
  dateFormat?: string;
  showMonthYearPicker?: boolean;
  showTwoColumnMonthYearPicker?: boolean;
  showFullMonthYearPicker?: boolean;
  useDefult?: boolean;
  inline?: boolean;
  showYearDropdown?: boolean;
  showMonthDropdown?: boolean;
  excludeDates?: Date[];
  showTimeSelect?: boolean;
  isClearable?: boolean;
}

interface CustomState {
  value?: Date;
}

class DateInput extends React.Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    gap: 'md',
    name: '',
    label: '',
    error: '',
    placeholder: '',
    dateFormat: 'dd/MM/yyyy',
    showMonthYearPicker: false,
    showTwoColumnMonthYearPicker: false,
    showFullMonthYearPicker: false,
    useDefult: false,
    inline: false,
    showYearDropdown: true,
    showMonthDropdown: true,
    showTimeSelect: false,
    isClearable: true,
  };
  constructor(props: CustomProps) {
    super(props);
    this.state = {
      value: this.props.default ? this.setDate(this.props.default) : undefined,
    };

    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.state = {
      value: this.props.default ? this.setDate(this.props.default) : undefined,
    };
  }

  componentDidUpdate(prevProps: CustomProps) {
    if (prevProps.default !== this.props.default) {
      this.updateDefault();
    }
  }

  updateDefault() {
    this.setState({
      value: this.props.default ? this.setDate(this.props.default) : undefined,
    });
  }

  setDate(dateValue: Date) {
    if (!this.props.useDefult) {
      return new Date(dateValue);
    }

    return dateValue;
  }

  handleChange(date: Date) {
    this.setState({
      value: date,
    });
    this.props.onChange(date);
  }
  render() {
    const {
      name,
      label,
      placeholder,
      error,
      minDate,
      maxDate,
      filterDate,
      disabled,
      dateFormat,
      showMonthYearPicker,
      showTwoColumnMonthYearPicker,
      showFullMonthYearPicker,
      inline,
      showYearDropdown,
      showMonthDropdown,
      showTimeSelect,
      isClearable,
    } = this.props;
    const inputIdCandidate = name || label || placeholder || '';
    const inputId = inputIdCandidate.toLowerCase().split(' ').join('-');
    return (
      <div className='input-group'>
        <DatePicker
          id={inputId}
          selected={this.state.value}
          onChange={this.handleChange}
          minDate={minDate}
          maxDate={maxDate}
          placeholderText={placeholder}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          dropdownMode='select'
          dateFormat={dateFormat}
          customInput={<CustomDateInput />}
          filterDate={filterDate}
          disabled={disabled}
          showMonthYearPicker={showMonthYearPicker}
          showTwoColumnMonthYearPicker={showTwoColumnMonthYearPicker}
          showFullMonthYearPicker={showFullMonthYearPicker}
          inline={inline}
          excludeDates={this.props.excludeDates || []}
          showTimeSelect={showTimeSelect}
          isClearable={isClearable}
        />

        {error && <span className='Input__error'>{error}</span>}
      </div>
    );
  }
}
export default DateInput;

const CustomDateInput = forwardRef((props, ref) => {
  const { id, placeholder, value, onClick }: { [key: string]: any } = props;
  return (
    <div>
      <input
        id={id}
        className='form-control form-date-picker rounded-sm font-weight-semibold bg-white'
        placeholder={placeholder}
        onClick={onClick}
        value={value}
        style={{ background: `url(${CalenderIco})` }}
        autoComplete='off'
      />
    </div>
  );
});
